import { defineStore } from 'pinia';
import { useAccountsStore } from './accounts';
import { useExcelAddinStore } from './excel-addin';
import { useAccessStore } from './access';
import { useGasStore } from './gas';
import { useGasTransitStore } from './gasTransit';
import { useIntradayStore } from './intraday';

const versionString =
  import.meta.env.MODE === 'development'
    ? import.meta.env.VITE_APP_VERSION + '-dev'
    : import.meta.env.VITE_APP_VERSION;

export const useMainStore = defineStore('main', {
  state: () => ({
    debug: import.meta.env.MODE === 'development',
    version: versionString,
    isInitialized: false,
    isOnboarded: false,
  }),
  persist: 
      {
        storage: localStorage,
        paths: ['isOnboarded'],
      },

  actions: {
    async initApp() {
      // general stores
      // if (this.isInitialized){
      //   return true;
      // }
      try {
        const accountsStore = useAccountsStore();
        await accountsStore.init();
        if (accountsStore.isLoggedIn){
          const today = new Date();
          const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
          const toLocalDateStr = (d: Date) => {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
          };
          const todayStr = toLocalDateStr(today);
          const yesterdayStr = toLocalDateStr(yesterday);
          await Promise.all([
            accountsStore.getAccountCommercial(),
            useExcelAddinStore().fetchContracts(),
            useAccessStore().fetchLatestSparkRCsv('174000', 'usd-per-mmbtu').catch(() => {}),
            useGasStore().fetchGasContracts('sparkleba-ttf-da', 'eur-per-mwh', yesterdayStr, todayStr).catch(() => {}),
            useGasTransitStore().fetchReferenceData().catch(() => {}),
            useIntradayStore().fetchFobPortReferenceData('arbs').catch(() => {}),
          ])
        }
      } finally {
        this.isInitialized = true;
      }
    },
    setOnboarded(flag: boolean) {
      this.isOnboarded = flag;
    },
  },

  getters: {
    isLoading: (state) => {
      return !state.isInitialized;
    },
  },
});
